import { graphql, StaticQuery } from "gatsby"
import React from "react"

const QueryLifestyleTopics: React.FC<{
  children: (heroImage: any, topics: any, articles: any) => any
}> = ({ children }) => {
  const query = graphql`
    query {
      heroImage: file(relativePath: { eq: "lifestyle-bg.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            aspectRatio
            base64
            sizes
            src
            srcSet
          }
        }
      }

      topics: allLifestyleTopicsYaml {
        edges {
          node {
            title
            description: excerpt
            slug: path
            order
            image {
              childImageSharp {
                fluid(maxWidth: 300) {
                  aspectRatio
                  base64
                  sizes
                  src
                  srcSet
                }
              }
            }
          }
        }
      }

      articles: allLifestyleArticlesYaml(
        filter: { discoverable: { eq: true } }
        sort: { fields: order }
      ) {
        edges {
          node {
            id
            title
            slug: path
            description: excerpt
            discoverable
            thumbnail {
              childImageSharp {
                fluid(maxWidth: 300) {
                  aspectRatio
                  base64
                  sizes
                  src
                  srcSet
                }
              }
            }
          }
        }
      }
    }
  `

  return (
    <StaticQuery query={query}>
      {data => (
        <>
          {children(
            data.heroImage,
            data.topics.edges.map(({ node }: any) => ({
              title: node.title,
              slug: node.slug,
              description: node.description,
              image: node.image.childImageSharp.fluid,
            })),
            data.articles.edges.map(({ node }: any) => ({
              title: node.title,
              slug: node.slug,
              description: node.description,
              image: node.thumbnail.childImageSharp.fluid,
            }))
          )}
        </>
      )}
    </StaticQuery>
  )
}

export default QueryLifestyleTopics
